import React from 'react';
import { Link } from 'gatsby';
import styled from "@emotion/styled";
import dimensions from 'styles/dimensions';
import { Inner } from 'styles/structure';
import Button from 'components/_ui/Button';
import colors from 'styles/colors';
import { Rubric } from 'styles/typography';

const TrapdoorContainer = styled.div`
  & + * {
    margin-top: 10.4rem;
  }
  
  &:last-child {
    margin-bottom: 12rem;
  }
`;

const TrapdoorCard = styled.div`
  background-color: ${colors.teal800};
  padding: 4rem 1.6rem;
  text-align: center;
  
  .is-brief & {
    h2 {
      max-width: 72.8rem;
    }
  }
  
  header {
    & + * {
      margin-top: 4rem;
    }
  }
  
  h2 {
    color: #fff;
    margin-left: auto;
    margin-right: auto;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 8.8rem 9.6rem 8rem;
  }
`;

const TrapdoorButtons = styled.div`
  text-align: center;
  
  a {
    &:hover {
      border-color: #fff;
    }
  }
`;

const Trapdoor = ({ intro, heading, buttonText, destination, external }) => {
  const isBrief = heading && heading.length < 80;

  return (
    <TrapdoorContainer className={isBrief && 'is-brief'}>
      <Inner>
        <TrapdoorCard>
          <header>
            {intro && <Rubric>{intro}</Rubric>}

            {heading && <h2>{heading}</h2>}
          </header>

          {(buttonText && destination) && (
            <TrapdoorButtons>
              {!external &&
                <Button as={Link} to={destination}>{buttonText}</Button>
              }

              {external &&
              <Button as={'a'} href={destination} target='_blank'>{buttonText}</Button>
              }
            </TrapdoorButtons>
          )}
        </TrapdoorCard>
      </Inner>
    </TrapdoorContainer>
  );
};

export default Trapdoor;
